module.exports = __webpack_public_path__ + "img/Sin título-1.7094ebd4.jpg";